import { getFromLocationNames } from "./batchMoveConfirmation";

const MULTIPLE_SITES_MESSAGE = "Disabled due to multiple sites selected";
const NO_SITE_MESSAGE = "Disabled due to items without a site selected";
const CHECKING_SELECTION_MESSAGE = "Checking the sites of the selected items";

const DISABLED = {
  disabled: true,
  fromLocationNames: [],
  itemCount: 0,
  selection: null,
  siteId: null,
};

// Select list rows wrap the warehouse item in `item`; search rows are the item.
const getSelectedWarehouseItem = row => row?.item ?? row;

const getSiteRestriction = siteIds => {
  if (siteIds.includes(null)) return NO_SITE_MESSAGE;
  if (siteIds.length > 1) return MULTIPLE_SITES_MESSAGE;
  return null;
};

const getAvailability = ({ fromLocationNames, itemCount, selection, siteIds }) => {
  if (itemCount === 0) return DISABLED;

  const restriction = getSiteRestriction(siteIds);
  if (restriction) return { ...DISABLED, title: restriction };

  return {
    disabled: false,
    fromLocationNames,
    itemCount,
    selection,
    siteId: siteIds[0],
  };
};

// "All" covers results beyond the current page, so its sites come from the
// server summary of `allSelection` rather than the loaded rows.
const getBatchMoveLocationAvailability = ({
  allSelection,
  allSelectionSummary,
  select,
  selectedRows = [],
}) => {
  if (select === "all") {
    if (!allSelectionSummary) {
      return { ...DISABLED, title: CHECKING_SELECTION_MESSAGE };
    }
    return getAvailability({
      fromLocationNames: allSelectionSummary.fromLocationNames ?? [],
      itemCount: allSelectionSummary.itemCount ?? 0,
      selection: allSelection,
      siteIds: allSelectionSummary.siteIds ?? [],
    });
  }

  const warehouseItems = selectedRows
    .map(getSelectedWarehouseItem)
    .filter(warehouseItem => warehouseItem?.id != null);
  const itemIds = [
    ...new Set(warehouseItems.map(warehouseItem => warehouseItem.id)),
  ];

  return getAvailability({
    fromLocationNames: getFromLocationNames(warehouseItems),
    itemCount: itemIds.length,
    selection: { itemIds },
    siteIds: [
      ...new Set(
        warehouseItems.map(
          warehouseItem => warehouseItem?.itemSite?.siteId ?? null,
        ),
      ),
    ],
  });
};

export {
  CHECKING_SELECTION_MESSAGE,
  getBatchMoveLocationAvailability,
  MULTIPLE_SITES_MESSAGE,
  NO_SITE_MESSAGE,
};
